import { BaseState } from './base_state';
import { getUniqueId } from 'goog:goog.events';

export type Size = { height?: number; width?: number };

/**
 * Used to store dimensions of the frame size
 */
export class SizeState extends BaseState {
  static readonly CHANGE = getUniqueId('size_change');
  private size_: Size = {};
  private initialSize_: Size = {};

  constructor() {
    super(SizeState.CHANGE);
  }

  getSize() {
    return this.size_;
  }

  reset() {
    this.size_.height = this.initialSize_.height;
    this.size_.width = this.initialSize_.width;
    this.dispatchChangeEvent();
  }

  setSize(size: Size) {
    if (size.height) {
      this.initialSize_.height ??= size.height;
      this.size_.height = size.height;
      this.dispatchChangeEvent();
    }
    if (size.width) {
      this.initialSize_.width ??= size.width;
      this.size_.width = size.width;
      this.dispatchChangeEvent();
    }
  }
}

// Get a singleton instatiation
const sizeState = new SizeState();
export default sizeState;
